import http from '@/utils/http' //引入axios

export const getDict = data => http.get('/dict', {
    params: data
}) //获取字典
export const addDict = data => http.post('/dict', data) //添加字典
export const updataDict = data => http.put('/dict', data) //編輯字典
export const deleteDict = data => http.delete('/dict', {
    params: data
}) //根据id刪除字典
export const updataDictMenu = data => http.put('/dict/menu', data) //編輯字典菜单
export const getSingleDict = data => http.get('/dictDetail', {
    params: data
}) //获取单个字典信息
export const editSingleDict = data => http.put('/dictDetail', data) //获取字典詳情
export const deleteDictInfo = data => http.delete('/dictDetail', {
    params: data
}) //根据id刪除字典詳情
export const addDictSingleInfo = data => http.post('/dictDetail', data) //添加字典詳情
export default {
    getDict,
    addDict,
    updataDict,
    deleteDict,
    updataDictMenu,
    getSingleDict,
    editSingleDict,
    deleteDictInfo,
    addDictSingleInfo
}